import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { useDeleteUserUsersIdDeleteMutation } from "api";
import { useNavigate } from "hooks/useNavigate";

type DeleteUserDialogProps = {
  userId: string;
};

export function DeleteUserDialog({ userId }: DeleteUserDialogProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [showDelete, setShowDelete] = useState(false);

  const [deleteUser, { isLoading }] = useDeleteUserUsersIdDeleteMutation();

  const handleDeleteUser = async () => {
    try {
      await deleteUser({ id: userId });

      navigate(`/administration`, { replace: true });
    } catch (error) {
      console.error("Failed to delete user:", error);
    }
  };

  return (
    <Box sx={{ alignSelf: "flex-end" }}>
      <Button color={"error"} onClick={() => setShowDelete(true)}>
        {t("delete_employee")}
      </Button>
      <Dialog open={showDelete} onClose={() => setShowDelete(false)}>
        <DialogTitle>{t("delete_employee")}</DialogTitle>
        <DialogContent dividers>
          {t(
            "Deleting this employee will remove all data associated with this employee. This action is non-reversable",
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color={"error"}
            onClick={handleDeleteUser}
            loading={isLoading}
          >
            {t("Delete")}
          </Button>
          <Button variant={"text"} onClick={() => setShowDelete(false)}>
            {t("Cancel")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
